import { color } from '$tablet-app/src/app/theme';
import React, { memo } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import PegasusAvatar from '../Pegasus/PegasusAvatar';
import Shadow from '../Shadow';

import { colors } from '@akin-home/theme';
import { useEffect } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
  Easing,
  Extrapolate,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

interface Props {
  listening?: boolean;
  avatar_image_asset?: any;
}

const AvatarBubble = ({ listening, avatar_image_asset }: Props) => {
  return (
    <View>
      {listening ? (
        <>
          <Pulse delay={1000} repeat />
          <Pulse delay={800} repeat />
          <Pulse delay={400} repeat />
          <Pulse delay={200} repeat />
          <Pulse repeat />
        </>
      ) : null}

      <BubbleShadow>
        <TouchableLayer />
        <InnerContainer>
          {avatar_image_asset ? (
            <AvatarImage source={avatar_image_asset} />
          ) : (
            <PegasusAvatar size="small" />
          )}
        </InnerContainer>
      </BubbleShadow>
    </View>
  );
};

const AvatarImage = styled.Image`
  height: 100px;
  width: 100px;
`;

const BubbleShadow = styled(Shadow)`
  border-radius: 50px;
  height: 100px;
  width: 100px;
  align-items: center;
  justify-content: center;
  background-color: ${color.white};
  overflow: hidden;
  position: relative;
`;

const TouchableLayer = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const InnerContainer = styled.View`
  height: 100px;
  width: 100px;
  background-color: transparent;
`;

export default memo(
  AvatarBubble,
  (prev_props, props) =>
    prev_props.listening === props.listening &&
    prev_props.avatar_image_asset === props.avatar_image_asset
);

interface PulseProps {
  delay?: number;

  repeat?: boolean;
}

export const Pulse = ({ delay = 0, repeat }: PulseProps) => {
  const animation = useSharedValue(0);

  useEffect(() => {
    animation.value = withDelay(
      delay,
      withRepeat(
        withTiming(1, {
          duration: 2000,
          easing: Easing.linear,
        }),
        repeat ? -1 : 1,
        false
      )
    );
  }, []);

  const animatedStyles = useAnimatedStyle(() => {
    const opacity = interpolate(
      animation.value,
      [0, 1],
      [0.6, 0],
      Extrapolate.CLAMP
    );
    return {
      opacity: opacity,
      transform: [{ scale: animation.value }],
    };
  });

  return <Animated.View style={[styles.circle, animatedStyles]} />;
};

const styles = StyleSheet.create({
  circle: {
    width: 200,
    height: 200,
    borderRadius: 100,
    borderColor: colors.primary[50],
    borderWidth: 2,
    backgroundColor: colors.primary[700],
    position: 'absolute',
    top: -50,
    left: -50,
  },
});
